import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'

class Loader extends Component {
  render () {
    return (
      <div className="Loader" style={{ backgroundSize: this.props.size + 'px' }}/>
    )
  }
}


Loader.defaultProps = {
  size: 100
}
Loader.propTypes = {
  size: PropTypes.number
}

export default Loader
